import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileExclamation } from '@fortawesome/pro-solid-svg-icons'

import { Box, Text } from '@domain-group/suit-theme'

const Outdated = () => (
  <Box
    position="absolute"
    bottom={0}
    left={0}
    right={0}
    top={0}
    alignItems="center"
    backgroundColor="rgba(255, 255, 255, 0.9)"
    color="bodyFontColor"
    flexDirection="column"
    justifyContent="center"
  >
    <FontAwesomeIcon style={{ fontSize: 'xxlarge' }} icon={faFileExclamation} />

    <Text fontSize="xsmall" marginTop="10px" textAlign="center">
      Outdated Revision
    </Text>
  </Box>
)

export default Outdated
